import { motion } from "framer-motion";
import { Download, ShieldCheck } from "lucide-react";

export const Nav = ({ count }) => {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-[#06090E]/80 backdrop-blur-xl border-b border-white/5"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo-link">
          <img src="/assets/cyrion-logo.png" alt="Cyrion emblem" className="w-9 h-9 rounded-lg object-cover ring-1 ring-gold/30" />
          <span className="font-display font-bold tracking-[0.22em] text-sm text-slate-100 group-hover:text-gold-soft transition-colors duration-300">
            CYRION
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] tracking-[0.18em] uppercase text-slate-400">
          <a href="#download" data-testid="nav-download-link" className="hover:text-gold transition-colors duration-300">Download</a>
          <a href="#manifesto" data-testid="nav-manifesto-link" className="hover:text-gold transition-colors duration-300">Manifesto</a>
          <a href="#vision" data-testid="nav-vision-link" className="hover:text-gold transition-colors duration-300">Vision</a>
          <a href="#faq" data-testid="nav-faq-link" className="hover:text-gold transition-colors duration-300">FAQ</a>
        </nav>
        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-2 font-mono text-[11px] text-mint" data-testid="nav-download-badge">
            <ShieldCheck className="w-3.5 h-3.5" />
            <span>{count.toLocaleString()} secured</span>
          </div>
          <a
            href="#download"
            data-testid="nav-download-btn"
            className="flex items-center gap-2 bg-gold text-ink font-display font-bold text-xs tracking-wide px-4 py-2 rounded-full hover:bg-gold-soft hover:shadow-[0_0_24px_rgba(212,175,55,0.35)] transition-all duration-300"
          >
            <Download className="w-3.5 h-3.5" />
            Get the App
          </a>
        </div>
      </div>
    </motion.header>
  );
};
